import React from "react";
import HappySchoolMyBusy from "./HappySchoolMyBusy";
import { getActiveSchoolId } from "./activeSchool";

// Trang độc lập cho vai trò không đi qua HappySchoolStaffPortal (vd "cntt")
// nhưng vẫn cần tự khai lịch bận — HappySchoolMyBusy vốn chỉ nhận schoolId
// qua prop, không tự lấy được khi gắn thẳng vào route.
const HappySchoolMyBusyPage = () => <HappySchoolMyBusy schoolId={getActiveSchoolId()} />;

export default HappySchoolMyBusyPage;
